import thomDropdown from "../../modules/dropdown/dropdown";

jQuery = $;
export default function recycleDetail() {
    if (typeof window.cdbRecycleDetParams !== 'undefined' && $('.thom-dropdown--options-item').length) {
        var options = {
            jsonData: window.cdbRecycleDetParams.jsonData ? window.cdbRecycleDetParams.jsonData : '',
            currentCriteriaId: window.cdbRecycleDetParams.currentCriteriaId ? window.cdbRecycleDetParams.currentCriteriaId : 0,
            imageBaseUrl: window.cdbRecycleDetParams.imageBaseUrl ? window.cdbRecycleDetParams.imageBaseUrl : '',
            translations: window.cdbRecycleDetParams.translations ? window.cdbRecycleDetParams.translations : []
        }

        let _currentCriteriaID = options.currentCriteriaId;
        let data = options.jsonData;
        // Add click event
        $('.thom-dropdown--options-item').off('click').on('click', function () {
            let selCriteriaID = $(this).attr("data-criteria-id");
            let selCriteriaLabel = $(this).html(); // annata selezionata

            if (_currentCriteriaID !== selCriteriaID) {
                $('.thom-dropdown--label-item').html(selCriteriaLabel); // update label criteria with selected one

                // Update image
                let _wine_image = data[selCriteriaID]['product_criteria_image'];
                if (_wine_image) {
                    $('#wineBottleImage img').animate({opacity: 0}, 300, function () {
                        $(this).attr('src', _wine_image);
                        $(this).animate({opacity: 1});
                    });
                }

                $("#recycle-detail-ajax .ajax-content").animate({opacity: 0}, 300, function () {

                    let _newHtml = '';
                    let _available_formats = data[selCriteriaID]['available_formats'];
                    let _recycle_element_by_criteria = data[selCriteriaID]['recycle_element_by_criteria'];

                    $("#recycle-detail-ajax .ajax-content .breadcrumbs").html(_available_formats);

                    // Trova gli elementi con large_formats diverso da false
                    const elementsWithLargeFormats = _recycle_element_by_criteria.filter(element => element.large_formats !== false);
                    const elementsWithStandardFormats = _recycle_element_by_criteria.filter(element => element.standard_formats !== false);
                    let _hasSwitch = elementsWithLargeFormats.length > 0;
                    let $switch = $("#recycle-detail-ajax .ajax-content .switch");
                    if (_hasSwitch) {
                        let standardFormatValue = elementsWithStandardFormats[0]['standard_formats'];
                        //const extractedStandardFormatPart = standardFormatValue.split("=")[1].trim();
                        //$switch.find('#standard').html(extractedStandardFormatPart);
                        $switch.find('#standard').html(standardFormatValue);
                        let largeFormatValue = elementsWithLargeFormats[0]['large_formats'];
                        //const extractedLargeFormatPart = largeFormatValue.split("=")[1].trim();
                        //$switch.find('#large').html(extractedLargeFormatPart);
                        $switch.find('#large').html(largeFormatValue);
                        $('.waste-dett .switch-btn input').prop("checked", false);
                        $switch.css('opacity', 1);
                    } else {
                        $switch.css('opacity', 0);
                    }

                    // Create the HTML for each item.
                    _recycle_element_by_criteria = addExtraParamsToElements(_recycle_element_by_criteria, options.imageBaseUrl, options.translations);
                    const _recycleItems = _recycle_element_by_criteria.map(createRecycleItemHTML, options.imageBaseUrl);

                    // And add it for each HTML template to the body.
                    _recycleItems.forEach(item => {
                        _newHtml += item;
                    });

                    _currentCriteriaID = selCriteriaID;
                    if (_newHtml) {
                        $("#recycle-detail-ajax .ajax-content #recycle-items-list").html(_newHtml);
                        initSizeFormats();
                        $("#recycle-detail-ajax .ajax-content").animate({opacity: 1}, 300);
                    }

                });
            }

        });
    }

    // Dropdown init
    thomDropdown();

    initSizeFormats();
}

function addExtraParamsToElements(array, url, traslations) {
    array.forEach(element => {
        element.url = url;
        element.lblrecycled = traslations.recycled;
        element.lblnorecycled = traslations.norecycled;
        element.large_formats = element.large_formats ? element.large_formats.replace(' bottiglia =', ':') : element.large_formats;
        element.standard_formats = element.standard_formats ? element.standard_formats.replace(' bottiglia =', ':') : element.standard_formats;
    });
    return array;
}

const createRecycleItemHTML = ({
                                   can_be_recycled,
                                   element_material,
                                   element_picture,
                                   element_type,
                                   large_formats,
                                   recycle_code,
                                   standard_formats,
                                   url,
                                   lblrecycled,
                                   lblnorecycled
                               }) => {
    // Funzione per creare il markup di un elemento <li>
    const createListItem = (size, format) => `
      <li data-size="${size}">
        <div class="image">
            <img src="${element_picture}" alt="${element_type}">
        </div>
        <div class="inner">
            <div class="item">
                <div class="text">
                    <div class="title">${element_type}</div>
                    <p>
                        <strong>${format}</strong><br>
                        ${element_material} 
                    </p>
                </div>
                <div class="ico">
                   <img src="${url}${recycle_code}.png" alt="${recycle_code}">
                   <span class="recycleitem ${can_be_recycled ? 'racd' : 'racind'}">
                        ${can_be_recycled ? lblrecycled : lblnorecycled}
                   </span>
                </div>
            </div>
        </div>
      </li>`;

    // Se large_formats è diverso da false, crea due elementi <li>
    if (large_formats !== false) {
        return `
          ${createListItem('standard_formats', standard_formats || 'N/A')}
          ${createListItem('large_formats', large_formats)}
        `;
    }

    // Altrimenti, crea un solo elemento <li>
    return createListItem('standard_formats', standard_formats || 'N/A');
};


function showLiByDataSize(value) {
    $('.waste-dett .list li').removeClass('show');
    $('.waste-dett .list li[data-size=' + value + ']').addClass('show');
}

function initSizeFormats() {
    var bottleSize = "standard_formats";
    showLiByDataSize(bottleSize);

    $('.waste-dett .switch-btn input').change(function () {
        bottleSize === "standard_formats" ? bottleSize = "large_formats" : bottleSize = "standard_formats";
        showLiByDataSize(bottleSize);
    });
}


function appo() {
    const data = {
        "artists": [{
            "name": "Boris Kein",
            "id": 801,
            "city": "London",
            "country": "UK",
            "tags": ["portrait", "events", "travel", "animals"],
            "tagline": "Beauty is everywhere",
            "price": 400,
            "portrait": "BorisKein.jpg"
        },]
    };

    /**
     * Create one big string with interpolated values
     */
    const createArtistHTML = ({
                                  name,
                                  id,
                                  city,
                                  country,
                                  tags,
                                  tagline,
                                  price,
                                  portrait
                              }) => `
  <div class="artist" id="artist-${id}">
    <a class="frame-link" href="#">
      <img class="photo" src="${portrait}" alt="${name}"/>
    </a>
    <h2 class="name">${name}</h2>
    <span class="description">
      <p class="country">${country}</p>
      <p class="city">${city}</p>
      <p class="tagline">${tagline}</p>
      <p class="price">${price}</p>
    </span>
    <span class="label">
      <ul class="tags-label">
        ${tags.map(tag => `
          <li class="tag-elm">
            <a href="#" class="tag">${tag}</a>
          </li>`
    ).join('')}
      </ul>
    </span>
  </div>`;

// Create the HTML for each artist.
    const artists = data.artists.map(createArtistHTML);

// And add it for each HTML template to the body.
    artists.forEach(artist => {
        document.body.innerHTML += artist;
    });
}